<template>
  <div class="content-card">
    <img :src="image"
      class="content-img w-full"
      alt="speakol"/>

      <div class="content-text">
        <div class="title text-center">
          <slot name="title"></slot>
        </div>
        <div class="text-center content-div content">
          {{ text }}
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ['image', 'title', 'text']
}
</script>
